export default "__VITE_ASSET__Cb$2pdeO__"